import { Box } from "@material-ui/core";
import styles from "./Banner.module.css";
import { Theme, makeStyles, createStyles } from "@material-ui/core/styles";

// Override styles.
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textBanner: {
      color: theme.palette.background.paper,
    },
  })
);

const Banner: React.FC = () => {
  /* Custom styles to overwrite theme */
  const classes = useStyles();

  return (
    <Box data-qatag="BannerContainer" className={styles.BannerContainer}>
      <Box data-qatag="BannerContent" className={styles.BannerContent}>
        <Box data-qatag="titleTextBox">
          <Box
            data-qatag="titleText"
            className={`${classes.textBanner} ${styles.titleBanner}`}
          >
            Become a Solve iQ Insider for Business!
          </Box>
          <Box
            data-qatag="indicatorBox"
            mt={1}
            mb={1}
            className={`${classes.textBanner} ${styles.titleSubtitle}`}
          >
            Insiders receive unlimited access to the Solve iQ Business service
            for 30 days at no cost*
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Banner;
